import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaxPreviewService {
private baseUrl = `${environment.apiUrl}/api/tax`   ;
  constructor(
    private http: HttpClient
  ) {}

  preview(
    entityCode: string,
    header: any,
    line: any
  ) {
    let url =`${this.baseUrl}/preview`;
    return this.http.post<any>(
      url,
      {
        entityCode,
        header,
        line
      }
    );
  }
}